"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySubLinks = void 0;
var color_1 = require("@theme-ui/color");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var CompanySubLinks = function () {
    var _a = react_i18next_1.useTranslation("jds"), t = _a.t, i18n = _a.i18n;
    var locale = i18n.language;
    var links = [
        {
            href: "https://www.jagex.com/" + locale + "/gender-pay-gap",
            label: t("footer:subMenu:genderPayGapReport", "Gender Pay Gap Report"),
        },
        {
            href: "https://www.jagex.com/" + locale + "/modern-slavery-act-transparency-statement",
            label: t("footer:subMenu:modernSlaveryActTransparencyStatement", "Modern Slavery Act Transparency Statement"),
        },
        {
            href: "https://www.jagex.com/" + locale + "/terms",
            label: t("footer:subMenu:termsAndConditions", "Terms & Conditions"),
        },
        {
            href: "https://www.jagex.com/" + locale + "/terms/privacy",
            label: t("footer:subMenu:privacyPolicy", "Privacy Policy"),
        },
        {
            href: "https://www.jagex.com/" + locale + "/terms/cookies",
            label: t("footer:subMenu:cookiePolicy", "Cookie Policy"),
        },
    ];
    return (react_1.default.createElement(theme_ui_1.Flex, { sx: {
            mt: 2,
            flexDirection: ["column-reverse", "column-reverse", "column-reverse", "column-reverse", "column"],
            "@media screen and (max-width: 1200px)": {
                mt: 2,
                mb: 5,
            },
        } },
        react_1.default.createElement(theme_ui_1.Box, { sx: {
                textAlign: ["center", "center", "center", "center", "right"],
            } },
            links.map(function (_a) {
                var href = _a.href, label = _a.label;
                return (react_1.default.createElement(theme_ui_1.Link, { sx: {
                        display: "inline-block",
                        padding: ["0 13px", "0 13px", "0 13px", "0 13px", "0 0 0 26px"],
                        mb: "22px",
                        fontSize: 15,
                        color: color_1.transparentize(theme_1.theme.colors.white, 0.5),
                        textDecoration: "none",
                    }, href: href, key: label, target: "_blank" }, label));
            }),
            react_1.default.createElement(theme_ui_1.Link, { sx: {
                    display: "block",
                    mb: "22px",
                    fontSize: 15,
                    color: color_1.transparentize(theme_1.theme.colors.white, 0.5),
                    textDecoration: "none",
                }, onClick: function () {
                    var _a;
                    (_a = window.Cookiebot) === null || _a === void 0 ? void 0 : _a.renew();
                } }, t("footer:subMenu:manageCookiePreferences", "Manage Cookie Preferences")))));
};
exports.CompanySubLinks = CompanySubLinks;
